<template>
    <div class="giving-item">
        <div v-if="!manual" class="numeral">{{ numeral + 3 }}</div>
        <div v-else class="numeral">{{ manual }}</div>
        <div class="giving-item__content">
            <h3>{{ heading }}</h3>
            <div v-if="content" class="giving-item__text">
                <p>{{ content }}</p>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        heading: "",
        content: "",
        numeral: "",
        manual: ""
    }
}
</script>

<style lang="scss" scoped>
.giving-item {
    display: flex;
    align-items: flex-start;
    padding-bottom: 3rem;
    margin-bottom: 4rem;
    border-bottom: 1px solid #cccccc;

    @include mobile {
        &:last-child {
            border-bottom: 0;
            margin-bottom: 0;
            padding-bottom: 0;
        }
    }

    h3 {
        @include titleText();
        font-size: 1.875rem;
        margin-bottom: 1rem;
    }

    p {
        margin-top: 0;
    }

    .numeral {
        color: var(--primary_colour);
        @include titleText();
        font-size: 5.625rem;
        margin-right: 2rem;
        line-height: 0.8;
    }

    @include iego {
        &__content {
            width: 100%;
        }
    }

    &__text {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        @include tablet-and-mobile {
            display: block;
        }

        p {
            flex-basis: 80%;
            margin-right: 1rem;
        }

        .button_link {
            align-self: stretch;
            margin: 0.2rem 0 1.2rem;

            @include iego {
                flex-grow: 1;
                flex-shrink: 0;
            }

            &::v-deep span {
                white-space: nowrap;
            }
        }
    }
}
</style>
